export { default, getServerSideProps } from 'components/landing/mcp/MarketplaceAnalyticsMcpPage'
